import { render } from "./Log.vue?vue&type=template&id=a74e8fb2"
import script from "./Log.vue?vue&type=script&lang=js"
export * from "./Log.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__